import { getElements } from "./lib/get-element.module"
import Hammer from 'hammerjs';
import { $, $$ } from "./lib/$.module";

const containerSelector = '.ce-mask_hero';
const itemSelector = '.ce-mask_hero-item';
const activeClass = 'active';
const activeSelector = `${itemSelector}.${activeClass}`;
const outClass = 'out';
const inClass = 'in';
const animationOutName = 'hero-out';
const animationInName = 'hero-in';
const delay = 10000;

const defaultOptions = {
	containerSelector,
	activeSelector,
	itemSelector,
	activeClass,
	outClass,
	inClass,
	animationOutName,
	animationInName,
	delay,
}


const _hero = (element, options) => {

	let to;

	const container = () => element.closest(options.containerSelector)
	const siblings = () => $$(options.itemSelector, container())
	const active = () => $(options.activeSelector, container())
	const outs = () => $$(`.${options.outClass}`, container())
	const ins = () => $$(`.${options.inClass}`, container())
	const get = i => siblings()[i]
	const length = () => siblings().length;
	const index = () => Array.prototype.indexOf.call(siblings(), active());

	const _mod = (a, b) => ((a % b) + b) % b

	const startDelay = () => {
		to = setTimeout(onDelayEnd, options.delay)
	}

	const stopDelay = () => {
		clearTimeout(to)
	}

	const onDelayEnd = () => {
		next();
	}

	const go = (oldIndex, newIndex) => {
		endOut();
		endIn();
		get(oldIndex).classList.add(options.outClass);
		get(oldIndex).classList.remove(options.activeClass);
		get(newIndex).classList.add(options.inClass);
		get(newIndex).classList.add(options.activeClass);
		stopDelay();
		startDelay()
	}

	const onEnd = (event) => {
		switch (event.animationName) {
			case options.animationOutName:
				endOut()
				break;
			case options.animationInName:
				endIn()
				break;
		}

	}

	const endOut = () => {
		outs().forEach(out => out.classList.remove(options.outClass))
	}

	const endIn = () => {
		ins().forEach(_in => _in.classList.remove(options.inClass))
	}

	const next = () => {
		let newIndex = _mod(index() + 1, length())
		go(index(), newIndex)
	}

	const prev = () => {
		let newIndex = _mod(index() - 1, length())
		go(index(), newIndex)
	}

    options = {
		...defaultOptions,
		...window.ceHeroOptions,
		...options,
		...element.dataset
	}

	// only allow options keys that are present in defaultOptions
	options = Object.fromEntries(Object.entries(options).filter(([key]) => defaultOptions.hasOwnProperty(key)));

	let hammer = Hammer(element);
	hammer.on('swipeleft', next)
	hammer.on('swiperight', prev)
	element.addEventListener('animationend', onEnd);
	startDelay();

}

const hero = (element, options) => {
	const els  = getElements(element)
	els.forEach((el) => {
		_hero(el, options)
	})

	let h = {}
	return h;
}

export { hero }
